"use client";

import { Suspense, useEffect, useState } from "react";
import { initAnalytics } from "analytics";
import { useCookieSettings } from "hooks/cookies/useCookieSettings";
import { TrackPageView } from "./TrackPageView";
import GoogleConsentMode from "analytics/GoogleConsentMode";

export const Analytics = () => {
  const {
    cookieSettings: { allowAnalytics, hasDismissed }
  } = useCookieSettings();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    // Initialize analytics only if the user has dismissed
    // the cookie settings modal
    if (hasDismissed && !initialized) {
      setInitialized(true);
      initAnalytics(allowAnalytics).catch((e) => {
        console.error("failed to initialize analytics", e);
      });
    }
  }, [hasDismissed, initialized, allowAnalytics]);

  return (
    <Suspense>
      <TrackPageView />
      <GoogleConsentMode />
    </Suspense>
  );
};
